/**
 * @generated SignedSource<<b5bcef8f94e0cd8c6ba5ed9b6ba37d95>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type LinearCreateExternalTicketPaneMutation$variables = {
  blockKey: string;
  destinationInfo: any;
  noteId: string;
  title: string;
};
export type LinearCreateExternalTicketPaneMutation$data = {
  readonly sendActionItemToIntegration: {
    readonly clientMutationId: string | null;
  } | null;
};
export type LinearCreateExternalTicketPaneMutation = {
  response: LinearCreateExternalTicketPaneMutation$data;
  variables: LinearCreateExternalTicketPaneMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "blockKey"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "destinationInfo"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "blockKey",
            "variableName": "blockKey"
          },
          {
            "kind": "Variable",
            "name": "destinationInfo",
            "variableName": "destinationInfo"
          },
          {
            "kind": "Literal",
            "name": "integrationProvider",
            "value": "LINEAR"
          },
          {
            "kind": "Variable",
            "name": "noteId",
            "variableName": "noteId"
          },
          {
            "kind": "Variable",
            "name": "title",
            "variableName": "title"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "SendActionItemToIntegrationPayload",
    "kind": "LinkedField",
    "name": "sendActionItemToIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "LinearCreateExternalTicketPaneMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "LinearCreateExternalTicketPaneMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "a7f42719f50e5744d4435cf2e1297236",
    "id": null,
    "metadata": {},
    "name": "LinearCreateExternalTicketPaneMutation",
    "operationKind": "mutation",
    "text": "mutation LinearCreateExternalTicketPaneMutation(\n  $blockKey: String!\n  $noteId: ID!\n  $title: String!\n  $destinationInfo: JSON!\n) {\n  sendActionItemToIntegration(input: {blockKey: $blockKey, noteId: $noteId, title: $title, destinationInfo: $destinationInfo, integrationProvider: LINEAR}) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "4e75cbea03e23a180a701f983904dc6f";

export default node;
